import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import PartialBlockToast from "components/PartialBlockToast/PartialBlockToast";
import { setUiBlock, setWsReadyStatuses } from "store/reducers/LogsSlice";
import { handleWebSocketCommandResult, setSrtSChedule } from "store/reducers/TabsSlice";
import { useAppSelector } from "hooks/redux";
import React from "react";
import { updateRobotStatus } from "store/reducers/RobotsSlice";

const LogsWebSocket = () => {
    const dispatch = useDispatch();
    const token = Cookies.get("access");
    const [toastConfig, setToastConfig] = useState(null);
    const shownToastsRef = useRef(new Set<string>());
    const { selectedRobotId } = useAppSelector((state) => state.robots);
    const pendingCommands = useAppSelector(
        (state) => state.logs.pendingCommands,
    );
    const pendingCommandsRef = useRef(pendingCommands);
    const logsSocketRef = useRef<WebSocket | null>(null);
    const requestedCommandIdsRef = useRef(new Set<number>());

    pendingCommandsRef.current = pendingCommands;

    const selectedRobotIdRef = useRef(selectedRobotId);
    selectedRobotIdRef.current = selectedRobotId;

    useEffect(() => {
        if (!token || !selectedRobotId) {
            return;
        }

        const ws_path = `${process.env.REACT_APP_SOCKET_SECURE}${process.env.REACT_APP_BASE_API_DOMAIN}/wss/logs/?token=${encodeURIComponent(token)}`;

        const LogsSocket = new WebSocket(ws_path);
        logsSocketRef.current = LogsSocket;
        requestedCommandIdsRef.current.clear();

        const requestPendingCommandResults = () => {
            if (LogsSocket.readyState !== WebSocket.OPEN) return;

            Object.keys(pendingCommandsRef.current).forEach((queueId) => {
                const tcpQueueId = Number(queueId);
                if (
                    !Number.isFinite(tcpQueueId) ||
                    requestedCommandIdsRef.current.has(tcpQueueId)
                ) {
                    return;
                }

                LogsSocket.send(
                    JSON.stringify({
                        action: "get_command_result",
                        tcp_queue_id: tcpQueueId,
                    }),
                );
                requestedCommandIdsRef.current.add(tcpQueueId);
            });
        };

        LogsSocket.onopen = () => {
            dispatch(setWsReadyStatuses(true));
            requestPendingCommandResults();
        };

        LogsSocket.onmessage = function (message) {
            try {
                const data = JSON.parse(message.data);

                if (data.type === "ui_block") {
                    const robot_id = data.robot_id;

                    dispatch(
                        updateRobotStatus({
                            robot_id,
                            event_type: data.event_type,
                            message: data.message,
                            created_at: data.created_at,
                            mode: data.mode,
                        }),
                    );
                    if (
                        data.robot_id &&
                        data.robot_id !== selectedRobotIdRef.current
                    ) {
                        return;
                    }
                    const messageKey = `${robot_id}_${data.message || "error"}`;

                    if (shownToastsRef.current.has(messageKey)) {
                        return;
                    }
                    if (data.mode === "full" || data.mode === "partial") {
                        shownToastsRef.current.add(messageKey);

                        setToastConfig({
                            message: data.message || "Произошла ошибка",
                            onClose: () => setToastConfig(null),
                        });
                    }
                } else if (
                    data.type === "srt_schedule" ||
                    data.type === "srt_shedule"
                ) {
                    dispatch(setSrtSChedule(data.items || data.schedule));
                } else if (data.type === "command_result") {
                    dispatch(handleWebSocketCommandResult(data));
                }
            } catch (error) {
                console.error("[LogsWS] Ошибка парсинга:", error);
            }
        };

        LogsSocket.onclose = (event) => {
            console.log(
                `[LogsWS] closed for robot ${selectedRobotId}`,
                event.wasClean ? "clean" : "dirty",
            );
        };

        LogsSocket.onerror = (error) => {
            console.error("[LogsWS] error:", error);
        };

        return () => {
            console.log(`[LogsWS] Closing socket for robot ${selectedRobotId}`);
            if (logsSocketRef.current === LogsSocket) {
                logsSocketRef.current = null;
            }
            requestedCommandIdsRef.current.clear();
            LogsSocket.close();
        };
    }, [dispatch, token, selectedRobotId]);

    useEffect(() => {
        const socket = logsSocketRef.current;
        if (!socket || socket.readyState !== WebSocket.OPEN) return;

        Object.keys(pendingCommands).forEach((queueId) => {
            const tcpQueueId = Number(queueId);
            if (
                !Number.isFinite(tcpQueueId) ||
                requestedCommandIdsRef.current.has(tcpQueueId)
            ) {
                return;
            }

            socket.send(
                JSON.stringify({
                    action: "get_command_result",
                    tcp_queue_id: tcpQueueId,
                }),
            );
            requestedCommandIdsRef.current.add(tcpQueueId);
        });
    }, [pendingCommands]);

    return toastConfig ? <PartialBlockToast {...toastConfig} /> : null;
};

export default LogsWebSocket;
 